export default __webpack_public_path__ + "static/media/bg_intro.db163613.svg";